import { t } from 'ttag';

export const defaultEmptyChartContent = t`No outputs for selected scenarios`;
